<template>
  <v-container fluid>
    <v-data-table :search="search" :headers="headers" :items="items" class="elevation-1 mt-4" dense>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Parâmetros de Senha</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Pesquisar..." single-line hide-details></v-text-field>
          <v-dialog v-model="dialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="text-h5">Edição do Item</span>
              </v-card-title>

              <v-card-text>
                <v-form ref="form" v-model="form">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          disabled
                          outlined
                          v-model="editedItem.nameParam"
                          label="Nome do Parâmetro"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field outlined v-model="editedItem.valueParam" label="Valor do Parâmetro" :rules="[rules.required]"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" tile outlined @click="close">Cancelar</v-btn>
                <v-btn color="primary darken-1" tile @click="save" :disabled="!form">Salvar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon small color="primary" @click="editItem(item)">edit</v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import Axios from 'axios';
import store from '@/store';
import { getRulesPassword, changeParameter } from '@/services/authentication';

export default {
  data: () => ({
    rules: {
      required: v => !!v || 'Este campo é obrigatório'
    },
    search: '',
    form: false,
    dialog: false,
    url: store.getters['authentication/getConfig'].API_URL,
    headers: [
      { text: '', value: 'action', sortable: false },
      { text: 'Nome do Parâmetro', value: 'nameParam' },
      { text: 'Valor do Parâmetro', value: 'valueParam' },
      { text: 'Mensagem', value: 'message' }
    ],
    items: [],
    editedIndex: -1,
    editedItem: {
      nameParam: null,
      valueParam: null,
      message: null,
      codParameter: null,
      resourceId: null
    }
  }),

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.getRulesPassword();
  },

  methods: {
    async getRulesPassword() {
      try {
        const { data } = await getRulesPassword();

        this.items = data;
      } catch (err) {
        store.dispatch('notification/showNotification', {
          color: 'error',
          text: err,
          showIconNotification: false
        });
      }
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    async save() {
      if (!this.$refs.form.validate(true)) return;

      if (this.editedIndex > -1) {
        const { resourceId: id, codParameter, valueParam } = this.editedItem;
        const { status } = await changeParameter(id, codParameter, valueParam);

        status === 204 &&
          store.dispatch('notification/showNotification', {
            color: 'success',
            text: 'Operação realizada com sucesso!',
            showIconNotification: false
          });

        this.getRulesPassword();
      }

      this.close();
    }
  }
};
</script>
